import {Component, OnInit, Input, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { TextboxModel } from '../textbox.model';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { ExpressionBuilderService } from '../../expression-builder/expression-builder.service';
import { AuthService } from 'src/app/core-api/services/auth/auth.service';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { COMPONENT_UI } from '../../workflow-components.models';
import { AbstractWorkflowResultComponent } from '../../@core/abstract-workflow-result.component';

@Component({
    selector: 'abw-textbox-result',
    templateUrl: './textbox-result.component.html',
    styleUrls: ['./textbox-result.component.scss']
})
export class TextboxResultComponent extends AbstractWorkflowResultComponent<TextboxModel> implements AfterViewInit {
    @ViewChild('kTextbox') public textbox: TextBoxComponent;
    formatStyle: any = null;

    constructor(
      protected workflowComponentsService: WorkflowComponentsService,
      protected expressionBuilderService: ExpressionBuilderService,
      protected authService: AuthService,
      protected cdf: ChangeDetectorRef,
    ) {
      super(workflowComponentsService, expressionBuilderService, authService, cdf);
    }
  
    ngAfterViewInit() {
      super.ngAfterViewInit();
      if (!!this.textbox) {
        this.textbox.input.nativeElement.type = this.getInputType();
      }
    }

    getInputType() {
      const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
      if (workflowComponent.INPUT_TYPE == 'password') {
        return 'password';
      }
      return 'text';
    }
}